import api from "@/api/api-v2-config";

export async function getWebsitebuildersAxios() {    
    return await api.get("Websitebuilders?pageNumber=1&pageSize=10000");
}

export async function getWebsitebuildersListAxios() {    
    return await api.get("websitebuilders/gettenantwebsites");
}

export async function getWebsitebuilderAxios() {    
    return await api.get("websitebuilders/gettenantwebsite");
}

export async function getWebsiteAxios() {    
    return await api.get("websitebuilders/gettenantwebsite");
}

export async function deleteWebsitebuildersAxios(id) {    
    return await api.delete("Websitebuilders?Id=" + id);
}

export async function postWebsitebuildersAxios(item) {    
    return await api.post("Websitebuilders", item);
}

export async function putWebsitebuildersAxios(item) {    
    return await api.put("Websitebuilders", item);
}

export async function getWebsitebuildersByIdAxios(id) {    
    return await api.get(`Websitebuilders/${id}`);
}